export const snakeToText = (text) => {
  if (!text) return '';
  
  // Replace underscores with spaces and split into words
  const words = text.split('_');
  
  // Capitalize first letter of each word and join with spaces
  return words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
